<script>
/**
 * renderer组件
 * 用于表格的默认单元格渲染
 */
export default {
  props: {
    render: Function,
    props: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  render(h) {
    if (!this.render || typeof this.render !== "function") {
      return <div>Render function not provided.</div>;
    }

    return this.render(h, this.props);
  }
};
</script>
